import React from 'react';
import classNames from 'classnames';
import { GENERAL } from '../constants';
import { connectToJSContext } from '../utils.jsx';
import { phoneFormat, formatHref } from '../../common/utils';

const joinStrings = (...strings) =>
    strings.filter(val => !!val).join(' ');

const ContactItem = ({ description, displayValue, href }) => {
    return (
        <div className="row contact-item">
            {description &&
                <strong className="contact-description col-xs-12 col-sm-3">
                    {description}
                    <span className="hidden-xs">:</span>
                </strong>
            }
            <span
                className={classNames(
                    'contact-value col-xs-12 col-sm-9',
                    { 'col-sm-offset-3': !description }
                )}
            >
                {href ? <a className="contact-value__link" href={href}>{displayValue}</a> : displayValue}
            </span>
        </div>
    );
};

const ProfileContact = ({
    phoneLabel,
    emailLabel,
    addressLabel,
    phone,
    email,
    address
}) => (
    <div className="c-profile__contact">
        {phone &&
            <ContactItem
                description={phoneLabel}
                displayValue={phoneFormat(phone, true).readable}
                href={formatHref("tel", phoneFormat(phone, true).link)}
            />
        }
        {email &&
            <ContactItem
                description={emailLabel}
                displayValue={email}
                href={formatHref("mailto", email)}
            />
        }
        {address &&
            <div>
                <ContactItem
                    description={addressLabel}
                    displayValue={joinStrings(address.street, address.suite)}
                />
                <ContactItem
                    displayValue={joinStrings(address.city, address.state, address.zip_code)}
                />
            </div>
        }
    </div>
);

const mapStateToProps = ({theme_data}) => {
    return {
        phoneLabel: (theme_data.labels && theme_data.labels.location_phone) || GENERAL.CONTACT.PHONE,
        emailLabel: (theme_data.labels && theme_data.labels.location_email) || GENERAL.CONTACT.EMAIL,
        addressLabel: (theme_data.labels && theme_data.labels.location_address) || GENERAL.CONTACT.ADDRESS
    };
};

export default connectToJSContext(mapStateToProps)(ProfileContact);



// WEBPACK FOOTER //
// ./components/profile/profile_contact.jsx